import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Analytics } from '@trello/atlassian-analytics';

import styles from './NavigationFooter.less';

export const NavigationFooter: FunctionComponent = () => {
  return (
    <>
      <div className={styles.integrationsSection}>
        <FormattedMessage
          id="templates.directory.looking-for-browser-extensions-add-ons-and-more"
          defaultMessage="Looking for browser extensions, add-ons, and more?"
          description="Looking for browser extensions, add-ons, and more?"
        />
        <a
          href="/integrations"
          onClick={(e) => {
            Analytics.sendClickedLinkEvent({
              linkName: 'integrationsNavigationMenuLink',
              source: 'publicDirectoryScreen',
            });
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage
            id="templates.directory.check-out-our-integrations"
            defaultMessage="Check out our integrations"
            description="Check out our integrations"
          />
        </a>
      </div>

      <div className={styles.integrationsSection}>
        <FormattedMessage
          id="templates.directory.you-can-build-power-ups-for-millions-of-people-who-use-trello-or-build-a-private-custom-power-up-for-your-team-or-company"
          defaultMessage="You can build Power-Ups for millions of people who use Trello, or build a private custom Power-Up for your team or company."
          description="Building power-up explanation."
        />{' '}
        <a
          href="https://developers.trello.com/docs/get-started"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            Analytics.sendClickedLinkEvent({
              linkName: 'customPowerUpLearnMoreHeaderLink',
              source: 'publicDirectoryScreen',
            });
          }}
        >
          <FormattedMessage
            id="templates.directory.learn-how-here"
            defaultMessage="Learn how here."
            description="Learn how here."
          />
        </a>
      </div>
    </>
  );
};
